import { ITeam } from './team.service';
import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';
import { ISalaryScaleGroup } from './salaryScaleGroup.service';


export class ILocation extends BaseEntity {
    name: string;
    street?: string;
    number?: string;
    zip?: string;
    city?: string;
    customerId?: number;
    accountId: string;
    teams: ITeam[];
    salaryScaleGroupId?: string;
    salaryScaleGroup?: ISalaryScaleGroup;
    caoSurcharge?: number;
}

export class LocationService extends BaseService<ILocation> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'crm/locations');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/location.service.ts